import classNames from 'classnames';

import {
  FilterBar,
  ScreenerV2FilterBar,
} from './components/FilterBar/FilterBar';
import { Header } from './components/Header';
import { usePageConfig } from './components/PageConfigProvider/PageConfigProvider';
import { PageType } from './components/PageConfigProvider/types';
import previewStyles from './components/SavedViews/saved-view-preview.module.css';
import { useSavedViewPreview } from './components/SavedViews/savedViewPreviewStore';
import { isScreenerV2Page } from './utils/routing-helpers';

export const CustomDashPageSpecificWrappers = ({
  children,
}: React.PropsWithChildren) => {
  const { config } = usePageConfig();
  const revelioPageId = config.revelioPageId;
  const isReportPage = config.type === PageType.REPORT;
  const isScreenerPage = isScreenerV2Page(revelioPageId);
  // The charts fade while a saved view is being previewed.
  const preview = useSavedViewPreview();
  const isPreviewing = preview !== null;

  if (isReportPage) {
    return (
      <>
        <Header isReportPage={true} />
        {children}
      </>
    );
  }

  const filterBar = isScreenerPage ? <ScreenerV2FilterBar /> : <FilterBar />;

  return (
    <>
      <Header isReportPage={false} />
      {filterBar}
      <div
        className={classNames(
          previewStyles.content,
          isPreviewing && previewStyles.dimmed
        )}
      >
        {children}
      </div>
      {preview && (
        // Absolute over the page, so it moves neither the chips nor the charts.
        <div className={previewStyles.overlay} aria-hidden="true">
          <span
            className={classNames(
              previewStyles.banner,
              previewStyles.pillMiddle
            )}
            data-testid="saved-view-preview-banner"
          >
            Previewing "{preview.name}" · click the view to apply
          </span>
        </div>
      )}
    </>
  );
};
